<template>
  <div class="header">
    <h1>JYG ESG 企業健檢</h1>
    <div
      v-if="isButtonShow('NOAPI')"
      @click="exportExcel"
      style="cursor: pointer"
      class="d-flex align-items-center cursor-pointer"
    >
      <img class="me-2" src="@/assets/icons/export.svg" alt="" /> 匯出Excel
    </div>
  </div>
  <div class="filter">
    <div class="d-flex">
      <div class="col-4 d-flex">
        <CFormSelect
          @change="filter = $event.target.value"
          class="me-3 rounded-pill filter-selector"
        >
          <option value="all" @change="filter = null">聯絡狀態： 全部</option>
          <option value="0" @change="filter = '0'">聯絡狀態： 未聯絡</option>
          <option value="1" @change="filter = '1'">聯絡狀態： 聯絡中</option>
          <option value="2" @change="filter = '2'">聯絡狀態： 已簽約</option>
          <option value="3" @change="filter = '3'">聯絡狀態： 已拒絕</option>
        </CFormSelect>
      </div>
    </div>
  </div>
  <CRow class="my-5 fw-bold col-12 mx-auto">
    <CCol xs="3" class="text-center text-nowrap ps-0">姓名</CCol>
    <CCol xs="2" class="text-center text-nowrap pe-0">測驗時間</CCol>
    <CCol xs="3" class="text-center">聯絡電話</CCol>
    <CCol xs="1" class="text-center text-nowrap">聯絡狀態</CCol>
    <CCol xs="3" class="text-center"> </CCol>
  </CRow>
  <CRow
    v-for="item in filteredList"
    :key="item.name"
    class="mb-4 border list d-flex align-items-center col-12 mx-auto"
  >
    <CCol xs="3" class="text-center">{{ item.name }}</CCol>
    <CCol xs="2" class="text-center pe-0">{{
      formatTimestamp(item.created)
    }}</CCol>
    <CCol xs="3" class="text-center">{{ item.company_phone }}</CCol>

    <CCol xs="1" class="text-center">
      <div
        class="state"
        :style="
          item.contact_status === '0'
            ? 'background: #9CA0A8;'
            : item.contact_status === '1'
            ? 'background: #ECA716;'
            : item.contact_status === '2'
            ? 'background: #74D39C;'
            : 'background: #FE988E;'
        "
      >
        {{
          item.contact_status === '0'
            ? '未聯絡'
            : item.contact_status === '1'
            ? '聯絡中'
            : item.contact_status === '2'
            ? '已簽約'
            : '已拒絕'
        }}
      </div>
    </CCol>
    <CCol xs="3" class="d-flex align-items-center justify-content-center">
      <CButton
        color="primary"
        @click="$router.push(`/user-management/contact-information/${item.id}`)"
        component="a"
        class="list-btn text-nowrap mx-2"
      >
        聯絡資訊
      </CButton>
      <button
        v-if="isButtonShow(item.user_id ?'questionnaire/edit-form-list':'sign/up')"
        :class="item.user_id ? 'bg-info' : 'bg-primary '"
        @click="
          item.user_id
            ? $router.push(
                `/user-management/user-enterprise-list/${item.user_id}`,
              )
            : $router.push(`/user-management/create-user/${item.id}`)
        "
        class="list-btn mx-2 text-nowrap border-0 rounded text-light"
      >
        {{ item.user_id ? '查看用戶' : '新增用戶' }}
      </button>
      <CButton
        v-if="isButtonShow('questionnaire/delete-form-list')"
        color="light"
        class="list-btn text-nowrap mx-2"
        @click="deleteInfo(item.id)"
      >
        刪除
        <img src="@/assets/icons/delete.svg" alt="" />
      </CButton>
    </CCol>
  </CRow>
  <MsgBox
    :show="showMsgBox"
    :errorCode="errorCode"
    :errorMsg="errorMsg"
    @close="showMsgBox = false"
  />
  <DeleteBox
    :show="showDeleteBox"
    :id="listId"
    @confirm="deleteUserReply"
    @close="showDeleteBox = false"
  />
</template>
<script>
import { ref } from '@vue/reactivity'
import useQuestionnaire from '@/composables/useQuestionnaire'
import MsgBox from '@/components/MsgBox.vue'
import DeleteBox from '@/components/DeleteBox.vue'
import { formatDate } from '@/utils/format-date.js'
import { computed } from '@vue/runtime-core'
import jsonToExcel from '@/utils/jsonToExcel'
import { useStore } from 'vuex'

export default {
  components: {
    MsgBox,
    DeleteBox,
  },
  setup() {
    const { getFormList, deleteFormList } = useQuestionnaire()
    const options = ref(['時間： 全部', 2, 3, 4])
    const formList = ref([])
    const showMsgBox = ref(false)
    const showDeleteBox = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const listId = ref('')
    const store = useStore()
    const getList = async () => {
      const res = await getFormList()
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        formList.value = res.ret['form-list']
      }
    }
    getList()
    const isButtonShow = (key)=>{
      if(store.state.userInfo.auth_data === true){
        return true
      }else{
        return Object.values(store.state.userInfo.auth_data).includes(key)
      }
    }
    const formatTimestamp = (timestamp) => {
      return formatDate(timestamp * 1000)
    }

    const deleteInfo = (id) => {
      listId.value = id
      showDeleteBox.value = true
    }

    const deleteUserReply = async () => {
      const res = await deleteFormList({ id: listId.value })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        await getList()
      }
      showDeleteBox.value = false
    }

    const filter = ref('all')
    const filteredList = computed(() => {
      return formList.value
        .filter((item) => {
          return filter.value === 'all'
            ? true
            : filter.value === item.contact_status
        })
        .sort((x, y) => {
          return y.created - x.created
        })
    })

    const exportExcel = () => {
      const status = {
        0: '未聯絡',
        1: '聯絡中',
        2: '已簽約',
        3: '已拒絕',
      }

      const exportData = filteredList.value.map((item) => {
        return {
          name: item.name,
          created: formatTimestamp(item.created),
          phone: item.company_phone,
          email: item.email,
          contact_status: status[item.contact_status],
        }
      })

      const headers = {
        name: '姓名',
        created: '測驗時間',
        phone: '聯絡電話',
        email: '電子郵件',
        contact_status: '聯絡狀態',
      }
      jsonToExcel(headers, exportData, 'user-reply')
    }

    return {
      options,
      formList,
      showMsgBox,
      errorMsg,
      formatTimestamp,
      getList,
      errorCode,
      deleteInfo,
      showDeleteBox,
      listId,
      filteredList,
      filter,
      exportExcel,
      deleteUserReply,
      isButtonShow
    }
  },
}
</script>
<style lang="scss" scoped>
div {
  cursor: default;
}
.header {
  padding: 40px 0px;
}
h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
}

.add-user {
  background: #d1e5ef;
  border-radius: 20px;
  height: 50px;
}
.filter {
  margin-top: 50px;
}

.search {
  right: 16px;
}
.list {
  height: 48px;
  border-radius: 20px;
}
.state {
  border-radius: 4px;
  color: #fff;
  width: 64px;
  height: 24px;
  font-size: 12px;
  display: flex;
  align-items: center;
  margin: auto;
  justify-content: center;
}
.list-btn {
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 64px;
  height: 24px;
  img {
    width: 16px;
    margin-left: 3px;
  }
}
</style>
